import { Add } from "@mui/icons-material";
import { Button, CircularProgress } from "@mui/material";
import React from "react";

import styles from "../ProfilePage.module.scss";

interface FreeTierWarningProps {
  loading: boolean;
  framesUsed: number;
  subscriptionReady: boolean;
  onUpgrade: () => void;
}

const FreeTierWarning: React.FC<FreeTierWarningProps> = ({
  loading,
  framesUsed,
  subscriptionReady,
  onUpgrade,
}) => {
  const freeFramesLeft = framesUsed < 0 ? -framesUsed : 0;

  return (
    <div className={styles.developerFreeTierWarning}>
      <span>⚠</span>
      <span>
        {freeFramesLeft > 0 ? (
          <>
            You have{" "}
            <strong>{freeFramesLeft.toLocaleString()} free frames</strong> to
            use. You will need to add a credit card to go over. Priced at{" "}
            <strong>$0.25 per frame</strong> once over.
          </>
        ) : (
          <>
            You have <strong>used all your free frames</strong>. Add a credit
            card to keep going, priced at <strong>$0.25 per frame</strong>.
          </>
        )}
      </span>
      {subscriptionReady ? (
        <Button
          disabled={loading}
          onClick={onUpgrade}
          sx={{
            background: "transparent",
            border: "1px solid #5a4a2a",
            borderRadius: "999px",
            color: "#e09a3a",
            fontSize: "13px",
            fontWeight: 500,
            padding: "6px 16px",
            textTransform: "none",
            whiteSpace: "nowrap",
            gap: "6px",
            "&:hover": { background: "#2a1f0a" },
            "&.Mui-disabled": {
              background: "transparent",
              border: "1px solid #5a4a2a",
              color: "#e09a3a",
              opacity: 0.7,
            },
          }}
        >
          {loading ? (
            <CircularProgress size={14} sx={{ color: "#e09a3a" }} />
          ) : (
            <>
              <Add sx={{ fontSize: 16 }} /> Add credit card
            </>
          )}
        </Button>
      ) : (
        <CircularProgress size={18} sx={{ color: "#e09a3a" }} />
      )}
    </div>
  );
};

export default FreeTierWarning;
